/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { useState } from 'react';
import ClinicianGroupFilters from './ClinicianGroupFilters';
import ClinicianGroupContent from './ClinicianGroupContent';
import { ClinicianGroupType } from '../../../enums/clinicianGroupType';

export function ClinicianGroupPage() {
  document.title = 'Clinician Group view';
  const [state, setState] = useState({
    orgUnitId: null,
    validFromDate: null,
    validToDate: null,
    clinicianGroupType: ClinicianGroupType.Active,
  });

  return (
    <React.Fragment>
      <ClinicianGroupFilters onSubmit={filtersState => setState(filtersState)} />
      <ClinicianGroupContent {...state} />
    </React.Fragment>
  );
}
